var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../shared/extensions/footprintGenerator/ipcImages/index.js");
var IpcImageHelper = require('../../../../shared/extensions/footprintGenerator/ipcImageHelper.js');

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");

var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var RadialRoundPadGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    var self = this;
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.colorList = [];
    this.bodyColorList = this.value("bodyColorList", true);

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return this.data.componentFamily();
        },
        function(value) {
            return this.data.componentFamily(value);
        },
        [this.data.componentFamily]
    );

    this.bodyColor = this.shadow("bodyColor",
        function() {
            return this.data.bodyColor();
        },
        function(value) {
            return this.data.bodyColor(value);
        },
        [this.data.bodyColor]
    );

    this.updateBodyColorList(this.data.componentFamily());

    this.data.componentFamily.onChange(this, function(val) {
        self.updateBodyColorList(val)
        self.setDefaultColorFromList(val)
    });

};

lib_core.inherit(RadialRoundPadGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
RadialRoundPadGeneratorInteractionModel.$class = 'RadialRoundPadGeneratorInteractionModel';

module.exports = RadialRoundPadGeneratorInteractionModel;

RadialRoundPadGeneratorInteractionModel.prototype.updateBodyColorList = function(val) {
    this.colorList = [];
    if(val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family['POLARIZED_CAPACITOR']
        || val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family['NONPOLARIZED_CAPACITOR']) {
        for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.CAPACITOR) {
            var r = cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.CAPACITOR[t].key;
            this.colorList.push([this.LCLZ(r, r), cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.CAPACITOR[t].value]);
        }
    } else if(val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family['POLARIZED_INDUCTOR']
        || val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family['NONPOLARIZED_INDUCTOR']) {
        for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.INDUCTOR) {
            var r = cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.INDUCTOR[t].key;
            this.colorList.push([this.LCLZ(r, r), cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.INDUCTOR[t].value]);
        }
    };

    this.bodyColorList(this.colorList);;
};

RadialRoundPadGeneratorInteractionModel.prototype.setDefaultColorFromList = function(val) {
    this.bodyColor(""); //Two component families having same default color then UI should update with default color after updating respective color list.

    if(val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["POLARIZED_CAPACITOR"]) {
        this.bodyColor(cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.CAPACITOR.Blue.value);
    } else if (val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["NONPOLARIZED_CAPACITOR"]) {
        this.bodyColor(cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.CAPACITOR.Black.value);
    } else if (val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["POLARIZED_INDUCTOR"]) {
        this.bodyColor(cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.INDUCTOR.Grey.value);
    } else if (val === cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["NONPOLARIZED_INDUCTOR"]) {
        this.bodyColor(cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.INDUCTOR.Black.value);
    }
};

RadialRoundPadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    var componentFamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family) {
        var c = cio_datamodel.IpcDataModel.PthComponentAttribute.type.RADIALROUND.family[t];
        componentFamilyList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, componentFamilyList)];
};

RadialRoundPadGeneratorInteractionModel.prototype.getInspectorElementForBodyColor = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('bodyColor', 'Body Color'), this.bodyColor, this.bodyColorList)];
};

RadialRoundPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('leadDiameter', 'Lead Diameter'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit)];
};

RadialRoundPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyDiameter', 'Body Diameter'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

RadialRoundPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForBodyColor());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForPadHoleRatio());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
